import type { User as APIUser } from 'c-sdk';
import type { User } from 'c-entity-types';
import initials from './initials';

export const userName = (user: User | APIUser | null | undefined) => user?.name ?? '';

export const userInitials = (user: User | APIUser, maxLength = 2) =>
    initials(userName(user), maxLength);
